import { FeatureToggler } from '../feature-toggler';

/**
 * @ignore
 */
export class TogglePointFunctionHelper {
  public static toggleRouterService: FeatureToggler = undefined;
}

export function initialize(service: FeatureToggler) {
  return () => {
    TogglePointFunctionHelper.toggleRouterService = service;
  };
}
